module.exports = __webpack_public_path__ + "static/img/blog.4fab73c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background/blog.png
// module id = fGDO
// module chunks = 1